import { ChangeDetectionStrategy, Component, input, signal } from "@angular/core";
import { CommonModule } from "@angular/common";
import { BulkError } from "@m19-board/strategies/strategy-bulk-upload-modal/bulk-import.service";
import { CsvField } from "@m19-board/services/csv-export.service";
import { IAccordionComponent, IButtonDirective, IIconComponent } from "@front/m19-ui";

export interface ReportUpdate<T> {
  original: T;
  updated: T;
}

export interface ReportCreation<T> {
  createdEntity: T;
}

/** Structural field shape for report tables — accepts both literal and widened BulkCsvField arrays. */
type ReportBulkCsvField<T> = {
  field: keyof T & string;
  title: string;
  placeHolder?: string;
  parse: (input: string) => unknown;
  csvField: CsvField<T>;
  readonly: boolean;
};

@Component({
  selector: "app-bulk-upload-report-content",
  imports: [CommonModule, IAccordionComponent, IButtonDirective, IIconComponent],
  templateUrl: "./bulk-upload-report-content.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BulkUploadReportContentComponent<T, IdK extends keyof T & string = keyof T & string> {
  fields = input<ReportBulkCsvField<T>[]>([]);
  entityIdField = input.required<IdK>();
  updates = input<ReportUpdate<T>[]>([]);
  creations = input<ReportCreation<T>[]>([]);
  errors = input<BulkError[]>([]);

  isErrorAccordionOpen = signal(false);
}
